"use strict";
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoStatus = exports.VideoSource = exports.VideoPricingType = exports.VideoPlayType = exports.VideoLogoVisibility = exports.VideoCardType = exports.VideoCardTargetExternalType = exports.VideoCardPosition = exports.SortOrder = exports.PurchaseType = exports.PurchaseStatus = exports.PurchaseOrderType = exports.MutationStatus = exports.MediaStatus = exports.LiveStatus = exports.ChannelSource = exports.ChannelPricingType = void 0;
//==============================================================
// START Enums and Input Objects
//==============================================================
var ChannelPricingType;
(function (ChannelPricingType) {
    ChannelPricingType["PRICING_PLAN"] = "PRICING_PLAN";
    ChannelPricingType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(ChannelPricingType = exports.ChannelPricingType || (exports.ChannelPricingType = {}));
var ChannelSource;
(function (ChannelSource) {
    ChannelSource["INTERNAL"] = "INTERNAL";
    ChannelSource["YOUTUBE"] = "YOUTUBE";
})(ChannelSource = exports.ChannelSource || (exports.ChannelSource = {}));
var LiveStatus;
(function (LiveStatus) {
    LiveStatus["DVR_PROCESSING"] = "DVR_PROCESSING";
    LiveStatus["EXPIRED"] = "EXPIRED";
    LiveStatus["FINISHED"] = "FINISHED";
    LiveStatus["PENDING"] = "PENDING";
    LiveStatus["RECONNECTING"] = "RECONNECTING";
    LiveStatus["SCHEDULED"] = "SCHEDULED";
    LiveStatus["STREAMING"] = "STREAMING";
})(LiveStatus = exports.LiveStatus || (exports.LiveStatus = {}));
var MediaStatus;
(function (MediaStatus) {
    MediaStatus["FAILED"] = "FAILED";
    MediaStatus["INITIALIZED"] = "INITIALIZED";
    MediaStatus["IN_PROGRESS"] = "IN_PROGRESS";
    MediaStatus["IN_QUEUE"] = "IN_QUEUE";
    MediaStatus["PREVIEW_READY"] = "PREVIEW_READY";
    MediaStatus["READY"] = "READY";
})(MediaStatus = exports.MediaStatus || (exports.MediaStatus = {}));
var MutationStatus;
(function (MutationStatus) {
    MutationStatus["ERROR"] = "ERROR";
    MutationStatus["SUCCESS"] = "SUCCESS";
})(MutationStatus = exports.MutationStatus || (exports.MutationStatus = {}));
var PurchaseOrderType;
(function (PurchaseOrderType) {
    PurchaseOrderType["RENT"] = "RENT";
    PurchaseOrderType["SALE"] = "SALE";
    PurchaseOrderType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(PurchaseOrderType = exports.PurchaseOrderType || (exports.PurchaseOrderType = {}));
var PurchaseStatus;
(function (PurchaseStatus) {
    PurchaseStatus["ACTIVE"] = "ACTIVE";
    PurchaseStatus["CANCELED"] = "CANCELED";
    PurchaseStatus["DECLINED"] = "DECLINED";
    PurchaseStatus["EXPIRED"] = "EXPIRED";
    PurchaseStatus["FAILED"] = "FAILED";
    PurchaseStatus["INITIALIZED"] = "INITIALIZED";
    PurchaseStatus["PENDING"] = "PENDING";
    PurchaseStatus["REFUNDED"] = "REFUNDED";
    PurchaseStatus["SUSPENDED"] = "SUSPENDED";
})(PurchaseStatus = exports.PurchaseStatus || (exports.PurchaseStatus = {}));
var PurchaseType;
(function (PurchaseType) {
    PurchaseType["RENT"] = "RENT";
    PurchaseType["SALE"] = "SALE";
    PurchaseType["SUBSCRIPTION"] = "SUBSCRIPTION";
})(PurchaseType = exports.PurchaseType || (exports.PurchaseType = {}));
var SortOrder;
(function (SortOrder) {
    SortOrder["CUSTOM_ASC"] = "CUSTOM_ASC";
    SortOrder["CUSTOM_DESC"] = "CUSTOM_DESC";
    SortOrder["TITLE_ASC"] = "TITLE_ASC";
    SortOrder["TITLE_DESC"] = "TITLE_DESC";
    SortOrder["UPDATED_ASC"] = "UPDATED_ASC";
    SortOrder["UPDATED_DESC"] = "UPDATED_DESC";
})(SortOrder = exports.SortOrder || (exports.SortOrder = {}));
var VideoCardPosition;
(function (VideoCardPosition) {
    VideoCardPosition["BOTTOM_LEFT"] = "BOTTOM_LEFT";
    VideoCardPosition["BOTTOM_RIGHT"] = "BOTTOM_RIGHT";
    VideoCardPosition["TOP_LEFT"] = "TOP_LEFT";
    VideoCardPosition["TOP_RIGHT"] = "TOP_RIGHT";
})(VideoCardPosition = exports.VideoCardPosition || (exports.VideoCardPosition = {}));
var VideoCardTargetExternalType;
(function (VideoCardTargetExternalType) {
    VideoCardTargetExternalType["FACEBOOK"] = "FACEBOOK";
    VideoCardTargetExternalType["TWITTER"] = "TWITTER";
    VideoCardTargetExternalType["YOUTUBE"] = "YOUTUBE";
})(VideoCardTargetExternalType = exports.VideoCardTargetExternalType || (exports.VideoCardTargetExternalType = {}));
var VideoCardType;
(function (VideoCardType) {
    VideoCardType["CHANNEL"] = "CHANNEL";
    VideoCardType["CUSTOM"] = "CUSTOM";
    VideoCardType["PRODUCT"] = "PRODUCT";
    VideoCardType["RECENT_VIDEO"] = "RECENT_VIDEO";
    VideoCardType["SOCIAL"] = "SOCIAL";
    VideoCardType["VIDEO"] = "VIDEO";
})(VideoCardType = exports.VideoCardType || (exports.VideoCardType = {}));
var VideoLogoVisibility;
(function (VideoLogoVisibility) {
    VideoLogoVisibility["ALWAYS"] = "ALWAYS";
    VideoLogoVisibility["CONTROL_BAR"] = "CONTROL_BAR";
})(VideoLogoVisibility = exports.VideoLogoVisibility || (exports.VideoLogoVisibility = {}));
var VideoPlayType;
(function (VideoPlayType) {
    VideoPlayType["AUTOGENERATED_TRAILER"] = "AUTOGENERATED_TRAILER";
    VideoPlayType["CLIP"] = "CLIP";
    VideoPlayType["CONTENT"] = "CONTENT";
    VideoPlayType["DEFAULT_TRAILER"] = "DEFAULT_TRAILER";
    VideoPlayType["STORYBOARD"] = "STORYBOARD";
    VideoPlayType["TRAILER"] = "TRAILER";
    VideoPlayType["UPLOADED_TRAILER"] = "UPLOADED_TRAILER";
})(VideoPlayType = exports.VideoPlayType || (exports.VideoPlayType = {}));
var VideoPricingType;
(function (VideoPricingType) {
    VideoPricingType["RENT"] = "RENT";
    VideoPricingType["SALE"] = "SALE";
})(VideoPricingType = exports.VideoPricingType || (exports.VideoPricingType = {}));
var VideoSource;
(function (VideoSource) {
    VideoSource["COMPUTER"] = "COMPUTER";
    VideoSource["DROPBOX"] = "DROPBOX";
    VideoSource["FACEBOOK"] = "FACEBOOK";
    VideoSource["GOOGLE_DRIVE"] = "GOOGLE_DRIVE";
    VideoSource["LIVE"] = "LIVE";
    VideoSource["VIMEO"] = "VIMEO";
    VideoSource["YOUTUBE"] = "YOUTUBE";
})(VideoSource = exports.VideoSource || (exports.VideoSource = {}));
var VideoStatus;
(function (VideoStatus) {
    VideoStatus["VISIBLE"] = "VISIBLE";
})(VideoStatus = exports.VideoStatus || (exports.VideoStatus = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=globalTypes.js.map